import makeStyles from '@mui/styles/makeStyles';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { ContactSupportText } from '../../../components';
import { fromOrder, useAppDispatch } from '../../../store';
import { order } from '../../../layout/routes';
import { OrderStatus } from '../../../models';
import { useNavigate, useQuery } from '../../../routes';

const useStyles = makeStyles(theme => (({
  dialogContent: {
    lineHeight: 1.5,
    fontSize: theme.spacing(2),
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: '#111827',
    textAlign: 'center',
    marginBottom: 12,
  },
  description: {
    color: '#6B7280',
    textAlign: 'center',
    marginBottom: 24,
    lineHeight: 1.5,
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  note: {
    textAlign: 'center',
    marginTop: 16,
    fontSize: 12,
    color: '#6B7280',
  },
})));

const ConfirmPaymentDialog = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { navigate, replaceQuery } = useNavigate();
  const { queryDictionary } = useQuery();

  const orderResponse = useSelector(fromOrder.selectOrderResponse);

  useEffect(() => {
    if (orderResponse?.status === OrderStatus.PENDING && orderResponse.stripeInvoiceUrl) {
      setShowConfirmPaymentDialog(true);
    }
  }, [orderResponse]);

  const [showConfirmPaymentDialog, setShowConfirmPaymentDialog] = useState(false);

  const handleCloseDialog = () => {
    setShowConfirmPaymentDialog(false);
    dispatch(fromOrder.resetOrderResponse());
    navigate(order.path, replaceQuery(queryDictionary()));
  };

  const openLink = () => {
    window.open(orderResponse?.stripeInvoiceUrl ?? '', '_blank');
  };

  return (
    <Dialog
      open={showConfirmPaymentDialog}
      id="payment-confirmation-dialog"
      onClose={handleCloseDialog}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          paddingX: 2,
          borderRadius: 1.5,
          maxWidth: 480,
        },
      }}
    >
      <DialogContent id="order-confirmation-dialog-content" className={classes.dialogContent}>
        <p className={classes.title}>
          <FormattedMessage
            id="page.checkout.payment.confirmation.title"
          />
        </p>
        <p className={classes.description}>
          <FormattedMessage
            id="page.checkout.payment.confirmation.content"
          />
        </p>
        <div className={classes.btnContainer}>
          <Button
            id="confirm-btn"
            variant="contained"
            onClick={openLink}
            sx={theme => ({
              height: theme.spacing(5),
              backgroundColor: '#5959EB',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#43509B',
              },
              fontWeight: 500,
            })}
          >
            <FormattedMessage
              id="page.checkout.payment.confirmation.button.text"
            />
          </Button>
        </div>
        <ContactSupportText />
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmPaymentDialog;
